module.exports = __webpack_public_path__ + "img/nodata_opting.c90dc46b.png";